import { Button, Flex, Heading } from '@chakra-ui/react'
import { organizationListContext } from 'brokertslib/src/context'
import type { OrganizationUnitPagedQuery } from 'BrokerTsLib/src/dtos'
import { OrganizationUnitType } from 'brokertslib/src/enums'
import { exportUrl, useGetAll } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { OrganizationsList } from '../../containers/organization/OrganizationList'
import { OrganizationListFilter } from '../../containers/organization/OrganizationListFilter'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { Add, Export } from '../../icons'

export const OrganizationListPage = () => {
  const navigate = useNavigate()

  const [filter, setFilter] = useState<OrganizationUnitPagedQuery>({
    name: '',
    showInvalid: false,
    showRootOnly: false,
    pageIndex: 1,
    showAllItems: true,
    types: [OrganizationUnitType.Partner],
  })

  const { data, refetch, isLoading: isLoading } = useGetAll(filter)
  const items = data?.data

  return (
    <Section>
      <Container>
        <PageContent>
          <organizationListContext.Provider
            value={{
              loading: isLoading,
              totalCount: items?.totalCount ?? 0,
              filter: filter,
              pageSize: 10,
              updateFilter: (f) => setFilter(f),
              reload: () => refetch(),
              currentPage: filter.pageIndex,
              setCurrentPage: () => { },
              setPageSize: () => { },
              showAllItems: true,
            }}
          >
            <PageToolbar
              leftElements={
                <Flex sx={{ gap: 4, alignItems: 'center' }}>
                  <Heading as="h1">Přehled organizací</Heading>
                </Flex>
              }
              rightElements={
                <Flex sx={{ gap: 4 }}>
                  <Button
                    colorScheme="gray"
                    onClick={() => window.open(exportUrl)}
                  >
                    <Export />
                    Exportovat
                  </Button>

                  <Button
                    colorScheme="primary"
                    onClick={() => navigate('/organization/create')}
                  >
                    <Add />
                    Vytvořit novou organizaci
                  </Button>
                </Flex>
              }
            />

            <Flex direction={'column'} gap={4}>
              <OrganizationListFilter />
              <OrganizationsList
                organizations={items?.items ?? []}
                withPaginator
              />
            </Flex>
          </organizationListContext.Provider>
        </PageContent>
      </Container>
    </Section>
  )
}
